import { FlexibleBlockBrickImage, FlexibleBlockProps, FlexibleBlockTemplateImage } from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils/blocks';
import { brickCommon } from './common';

export const getImageBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateImage>[] => {
  const brickImage: FlexibleBlockBrickImage = {
    ...brickCommon,
    brickType: 'image',
    brickName: 'Image',
    switchable: true,
    src: '/assets/img/blocks/image/image.jpg',
    className: ['m-0'],
  };

  return [
    {
      title: 'Image',
      template: { type: 'image', view: 'basic' },
      bricks: [{ ...brickImage, index: 0 }],
      className: [],
      wrapper: getWrapperProps('none'),
    },
  ];
};
